<template>
  <el-form
    ref="loginForm"
    :model="credentials"
    :rules="rules"
    label-width="0em"
    label-position="left"
  >
    <template v-if="itemVisible('title',mode)" >
      <h1 style="text-align:center;">{{ title }}</h1>
    </template>

    <template v-if="itemVisible('customanswer',mode)" >
      <div class="explanation-title">▮ 確認コードについて</div>
      <div class="explanation">・メールで通知されるコードを入力してください</div>
      <el-form-item>
        <el-input
          v-model="customanswer"
          placeholder="確認コード"
          :clearable="true"
          :maxlength="6"
          :autofocus="autofocus"
        ></el-input>
      </el-form-item>
    </template>

    <template v-if="itemVisible('userId',mode)" >
      <el-form-item class="user-id" prop="userId">
        <el-input v-model="credentials.userId" placeholder="ユーザーID" prefix-icon="el-icon-user"></el-input>
      </el-form-item>
    </template>
    <template v-if="itemVisible('userIdComment',mode)" >
      <div class="explanation">当画面にてユーザーIDを入力すると登録されている</div>
      <div class="explanation">メールアドレスへ確認コードがメール送付されます。</div>
      <div class="explanation">次画面で通知された確認コードを入力しパスワード</div>
      <div class="explanation">を変更してください。</div>
    </template>

    <template v-if="itemVisible('newpassword',mode)" >
      <div class="explanation-title">▮ 新パスワードについて</div>
      <div class="explanation">・8文字以上で指定してください</div>
      <div class="explanation">・半角英字、数字、記号を含めてください</div>
      <div class="explanation">・利用可能な記号 !#$%&=~/*-+@</div>
      <el-form-item>
        <el-input
          type="password"
          v-model="newpassword"
          placeholder="パスワード"
          :clearable="true"
          :maxlength="20"
          :autofocus="autofocus"
          show-password
          prefix-icon="el-icon-lock"
        ></el-input>
      </el-form-item>
      <div class="explanation">・新パスワードを再度入力してください</div>
    </template>

    <template v-if="itemVisible('password',mode)" >
      <el-form-item class="password" prop="password">
        <el-input v-model="credentials.password" placeholder="パスワード" :maxlength="20" show-password prefix-icon="el-icon-lock"></el-input>
      </el-form-item>
    </template>

    <template v-if="itemVisible('LoginButton',mode)" >
      <el-row>
        <el-col>
          <div class="login-button">
            <el-button type="primary" @click.prevent="clickLogin">ログイン</el-button>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <div class="forgotPassword">
            <el-link type="danger" @click.prevent="resetPassword">パスワードを忘れた場合は、ここをクリック</el-link>
          </div>
          <!-- <div class="version">{{ version }}</div> -->
        </el-col>
      </el-row>
    </template>
    <template v-if="itemVisible('ChangeButton',mode)" >
      <el-row>
        <el-col>
          <div class="login-button">
            <el-button type="primary" @click="cancel">戻る</el-button>
            <el-button type="primary" @click.prevent="changePassword">パスワード変更</el-button>
          </div>
        </el-col>
      </el-row>
    </template>
    <template v-if="itemVisible('NextButton',mode)" >
      <el-row>
        <el-col>
          <div class="login-button">
            <el-button type="primary" @click="cancel">戻る</el-button>
            <el-button type="primary" @click.prevent="next">次へ</el-button>
          </div>
        </el-col>
      </el-row>
    </template>
    <template v-if="itemVisible('ConfirmButton',mode)" >
      <el-row>
        <div class="login-button">
          <el-col>
            <div class="login-button">
              <el-button type="primary" @click="cancel">戻る</el-button>
              <el-button type="primary" @click="onetime">確認</el-button>
            </div>
          </el-col>
        </div>
      </el-row>
    </template>
  </el-form>

</template>

<script>
import { Auth } from 'aws-amplify'
import { AmplifyEventBus } from 'aws-amplify-vue'
// import { API } from '@aws-amplify/api'
Auth.configure({
  authenticationFlowType: 'CUSTOM_AUTH'
})

export default {
  components: {
  },
  props: {
    currentRow: {
      type: Object,
      default: () => {
        return {}
      }
    },
    mode: {
      type: String,
      default: 'Login'
    },
    title: {
      type: String,
      default: 'パスワード変更'
    },
    visible: Boolean
    // forgotPassword: {
    //   type: Boolean,
    //   default: false
    // }
  },
  data () {
    return {
      credentials: {
        userId: '',
        password: ''
      },
      valid: true,
      rules: {
        userId: [
          { required: true, message: 'ユーザーIDを入力してください（必須入力）', trigger: 'blur' }
        ],
        password: [
          { required: true, message: 'パスワードを入力してください（必須入力）', trigger: 'blur' }
        ]
      },
      loginUser: {},
      errorType: '',
      nextTitle: '',
      // version: 'Ver:20210527 170000',
      username: '',
      password: '',
      newpassword: '',
      customanswer: '',
      useremail: '',
      challenge: {}
    }
  },
  methods: {
    itemVisible: function (item, stage) {
      var stageList = []

      if (stage === 'Login') {
      }
      switch (stage) {
        case 'Login':
          this.title = process.env.VUE_APP_SYSTEM_NAME
          break
        case 'ResetStart':
          this.title = 'ユーザーID入力'
          break
        case 'ResetPassword':
          this.title = 'パスワードリセット'
          break
      }

      if (item === 'title') { stageList = ['Login', 'newPassword', 'ResetStart', 'customChallenge', 'ResetPassword'] }
      if (item === 'customanswer') { stageList = ['customChallenge', 'ResetPassword'] }
      if (item === 'userId') { stageList = ['Login', 'ResetStart'] }
      if (item === 'userIdComment') { stageList = ['ResetStart'] }
      if (item === 'newpassword') { stageList = ['newPassword', 'ResetPassword', 'ChangePassword'] }
      if (item === 'password') { stageList = ['Login', 'newPassword', 'ResetPassword', 'ChangePassword'] }
      if (item === 'LoginButton') { stageList = ['Login'] }
      if (item === 'NextButton') { stageList = ['ResetStart'] }
      if (item === 'ChangeButton') { stageList = ['newPassword', 'ResetPassword'] }
      if (item === 'ConfirmButton') { stageList = ['customChallenge'] }

      return stageList.includes(stage)
    },
    async clickLogin () {
      try {
        this.$session.start()
        this.$loadingMask.on()
        this.challenge = await Auth.signIn(this.credentials.userId, this.credentials.password)
        await this.auth_user()
      } catch (err) {
        if (err.message.includes('Incorrect username or password')) {
          this.$message.error({
            message: 'ユーザーIDまたはパスワードに誤りがあります。',
            showClose: true
          })
        } else if (err.message.includes('Username cannot be empty')) {
          this.$message.error({
            message: 'ユーザーIDを入力してください。',
            showClose: true
          })
        } else if (err.message.includes('out of range')) {
          this.$message.error({
            message: 'パスワードを入力してください。',
            showClose: true
          })
        } else if (err.message.includes('Temporary password has expired and must be reset by an administrator')) {
          this.$message.error({
            // 'Temporary password has expired and must be reset by an administrator'
            message: '仮パスワードの有効期限が切れています。管理者へご連絡ください。',
            showClose: true
          })
        } else {
          this.$message.error({
            message: err.message,
            showClose: true
          })
        }
        this.mode = 'Login'
      } finally {
        this.$loadingMask.off()
      }
    },
    async nextPage () {
      this.$loginuser.set()
      var defaultYM = await this.defaultBillingYm()
      this.$session.set('latestBillingYM', defaultYM)
      var defaultAP = await this.defaultOwnAirport()
      this.$session.set('ownAirport', defaultAP)
      this.$router.push('/index')
    },
    async auth_user () {
      if (await this.isSignedIn()) {
        await this.nextPage()
        this.mode = 'signedIn'
        return
      }
      switch (this.challenge.challengeName) {
        case 'NEW_PASSWORD_REQUIRED':
          this.mode = 'newPassword'
          this.title = 'パスワード変更'
          this.credentials.password = ''
          break
        case 'CUSTOM_CHALLENGE':
          this.mode = 'customChallenge'
          this.title = '確認コード入力'
          this.customanswer = ''
          break
        default:
          throw Exception('Unknown challenge; something is wrong') /* global Exception */
      }
    },
    async isSignedIn () {
      try {
        (await Auth.currentAuthenticatedUser())
        return true
      } catch (err) {
        return false
      }
    },
    async onetime () {
      try {
        this.$loadingMask.on()
        this.challenge = await Auth.sendCustomChallengeAnswer(this.challenge, this.customanswer)
        await this.auth_user()
      } catch (err) {
        if (err.message.includes('Invalid session for the user')) {
          this.$message.error({
            message: 'はじめからやり直してください。',
            showClose: true
          })
        } else {
          this.$message.error({
            // message: 'Code is wrong..',
            message: 'コードが無効です、 はじめからやり直してください。',
            showClose: true
          })
        }
        this.mode = 'Login'
        this.credentials.userId = ''
      } finally {
        this.$loadingMask.off()
      }
    },
    async signOut () {
      try {
        this.$loadingMask.on()
        await Auth.signOut()
        this.mode = 'Login'
      } catch (e) {
        alert(e)
      } finally {
        this.$loadingMask.off()
      }
    },
    async changePassword () {
      try {
        this.$loadingMask.on()
        var passwordMessage = await this.checkPassword(this.newpassword, this.credentials.password)
        if (passwordMessage === '') {
          switch (this.mode) {
            case 'newPassword':
              this.challenge = await Auth.completeNewPassword(this.challenge, this.credentials.password)
              await this.auth_user()
              break
            case 'ResetPassword':
              if (this.customanswer.trim() === '') {
                this.$message.error({
                  message: '確認コードを入力してください。',
                  showClose: true
                })
                break
              }
              await Auth.forgotPasswordSubmit(
                this.credentials.userId,
                this.customanswer, // 認証コード
                this.credentials.password // 新しいパスワード
              )
              this.$message.success({
                message: 'パスワードが変更されました。新しいパスワードでログインしてください。',
                showClose: true
              })
              this.mode = 'Login'
              this.credentials.password = ''
              break
            default:
          }
        } else {
          await this.$fcMessage.showMessage(passwordMessage)
        }
      } catch (err) {
        if (err.message.includes('Password changed successfully')) {
          this.$message.success({
            // message: 'Changed password. Please sign in with new password!',
            message: 'パスワードが変更されました。新しいパスワードでログインしてください。',
            showClose: true
          })
          this.mode = 'Login'
          this.credentials.password = ''
        } else if (err.message.includes('Password cannot be empty')) {
          this.$message.error({
            message: 'パスワードを入力してください。',
            showClose: true
          })
        } else if (err.message.includes('Password does not conform to policy')) {
          this.$message.error({
            message: 'パスワードは8文字以上、半角英数記号で入力してください。',
            showClose: true
          })
        } else if (err.message.includes('Invalid session for the user')) {
          this.$message.error({
            message: 'はじめからやり直してください。',
            showClose: true
          })
          this.mode = 'Login'
          this.credentials.password = ''
        } else if (err.message.includes('Invalid verification code provided, please try again.')) {
          this.$message.error({
            message: '確認コードが無効です、 はじめからやり直してください。',
            showClose: true
          })
          this.mode = 'Login'
          this.credentials.userId = ''
          this.credentials.password = ''
        } else {
          this.$message.error({
            message: err.message,
            showClose: true
          })
        }
      } finally {
        this.$loadingMask.off()
      }
    },
    async next () {
      try {
        this.$loadingMask.on()
        if (this.credentials.userId.trim() === '') {
          this.$message.error({
            message: 'ユーザーIDを入力してください。',
            showClose: true
          })
        } else {
          await Auth.forgotPassword(this.credentials.userId)
          this.mode = 'ResetPassword'
          this.customanswer = ''
          this.credentials.password = ''
          this.newpassword = ''
        }
      } catch (err) {
        if (err.message.includes('Attempt limit exceeded, please try after some time.')) {
          this.$message.error({
            message: 'パスワード変更　試行回数を超えました。しばらく時間をおいて再度実行してください。',
            showClose: true
          })
        } else {
          this.$message.error({
            message: err.message,
            showClose: true
          })
        }
      } finally {
        this.$loadingMask.off()
      }
    },
    async resetPassword () {
      try {
        this.$loadingMask.on()
        this.mode = 'ResetStart'
      } catch (err) {
        this.$message.error({
          message: err.message,
          showClose: true
        })
      } finally {
        this.$loadingMask.off()
      }
    },
    cancel () {
      this.mode = 'Login'
      this.customanswer = ''
      this.credentials.userId = ''
      this.credentials.password = ''
      this.newpassword = ''
    }
    // async $_fetch (path) {
    //   try {
    //     const response = await API.get(process.env.VUE_APP_API_NAME, path)
    //     this.$message.info({
    //       message: 'API response: ' + response.message,
    //       showClose: true
    //     })
    //   } catch (err) {
    //     this.$message.error({
    //       message: err.message,
    //       showClose: true
    //     })
    //   }
    // }
  },
  async created () {
    if (await this.isSignedIn()) {
      this.mode = 'signedIn'
    }
    AmplifyEventBus.$on('authState', async info => {
      if (await this.isSignedIn()) {
        this.mode = 'signedIn'
      }
    })
  }
}
</script>
<style lang="scss" scoped>
.user-id {
    margin-top: 3em;
}
.login-button {
  text-align: center;
  margin-top: 1em;
  margin-bottom: 1em;
}
.forgotPassword {
  text-align: center;
  color: red;
}
.version {
  margin-top:10px;
  text-align: center;
  color: blue;
}
.el-form-item__label {
  width : 8em !important;
}
.explanation-title {
  color: #808080 !important;
  line-height: initial;
}
.explanation {
  color: #808080 !important;
  line-height: initial;
  margin-left: 15px;
}
</style>
